import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

interface FieldChange {
  campo: string;
  valorOriginal: string;
  novoValor: string;
}

@Component({
  selector: 'app-sling-log-detail',
  templateUrl: './sling-log-detail.component.html',
  styleUrls: ['./sling-log-detail.component.scss'],
    providers: [DatePipe]
})
export class SlingLogDetailComponent implements OnInit {
  constructor(private datePipe: DatePipe,
      private config: DynamicDialogConfig,
  ) {}

   rawString ="";
  campos: FieldChange[] = [];

  ngOnInit() {
    this.rawString = this.config.data;
    this.campos = this.parseString(this.rawString);
  
  }

parseString(input: string): FieldChange[] {
  const partes = input.split(';');

  return partes
    .map((item) => {
      const [campoRaw, valoresRaw] = item.split('@');
      if (!campoRaw || !valoresRaw) return null;

      const campo = campoRaw.trim();
      const valores = valoresRaw.split('|');

      const valorOriginal = valores[0]?.trim() ?? '';
      const novoValor = valores[1]?.trim() ?? '';

      return { campo, valorOriginal, novoValor };
    })
    .filter((campo): campo is FieldChange => campo !== null);
}

isValidDate(value: any): boolean {
  if (typeof value !== 'string') return false;

  const regex = /^(\d{2}\/\d{2}\/\d{4}|\d{4}-\d{2}-\d{2})(T\d{2}:\d{2}(:\d{2})?)?$/;

  if (!regex.test(value)) return false;

  const parsedDate = new Date(value);
  return !isNaN(parsedDate.getTime());
}

  formatarDataSeForData(valor: string): string {
    if (!this.isValidDate(valor)) {
      return valor;
    }
    const data = Date.parse(valor);
    if (!isNaN(data)) {
      return this.datePipe.transform(data, 'dd/MM/yyyy HH:mm:ss');
    }
    return valor;
  }
}
